"use client";
export default function OnboardingProgress({ step, total = 4 }: { step: number; total?: number }) {
  const pct = Math.max(0, Math.min(100, Math.round((step / total) * 100)));
  return (
    <div className="mb-2">
      <div className="flex items-center justify-between text-sm mb-1">
        <div>Step {step} of {total}</div>
        <div className="tabular-nums text-muted-foreground">{pct}%</div>
      </div>
      <div className="h-2 rounded bg-black/10 dark:bg-white/15 overflow-hidden">
        <div className="h-full bg-black dark:bg-white" style={{ width: pct + '%' }} />
      </div>
    </div>
  );
}
